<template> 
  <div class="card dashboard-card" :class="'dashboard-panel-'+panelSize">
    <div class="card-body d-flex justify-content-center" v-if="error">
      {{errorMessageDisplayed}}
    </div>
    <div class="card-body" :class="backgroundClass" v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DashboardPanelTemplate',
    props: {
      panelFocus: {
        type: Boolean,
        default: false,
        required: false
      },
      panelSize: {
        type: String,
        default: 'large',
        required: true
      },
      background: {
        type: String,
        default: '',
        required: false
      },
      loading: {
        type: Boolean,
        default: false,
        required: false
      },
      error: {
        type: Boolean,
        default: false,
        required: false
      },
      errorMessage: {
        type: String,
        default: null,
        required: false
      }
    },
    computed: {
      backgroundClass () {
        if (this.loading) return 'loading'
        if (this.panelFocus) return 'dashboard-panel-focus'
        switch (this.background) {
          case 'rocketShip': return 'rocketship-background'
          case 'mlm-shipping-bottom-left': return 'mlm-shipping-bottom-left-background'
          case 'mlm-shipping-bottom-right': return 'mlm-shipping-bottom-right-background'
          case 'banner': return 'banner-background'
          default: return ''
        }
      },
      errorMessageDisplayed () {
        return this.errorMessage || this.$t('DefaultErrorMessage')
      }
    },
    i18n: {
      messages: {
        'en-US': {
          DefaultErrorMessage: 'Hm...we couldn\'t load data. Please refresh your browser and if you have issues, let our support team know.'
        }
      }
    }
  }
</script>

<style scoped lang='scss'>
@import '@/../assets/scss/shipbob-custom/components/dashboard/_dashboard-panel-template.scss';
</style>
